/* cw-testimonials-editor — owner editing for the testimonial wall.
 *
 * Same gap the Locations editor closed, one section over: the wall has rendered
 * from shop metafield custom.testimonials since it was built, but changing it
 * meant the Shopify metafield editor — raw JSON, no validation, easy to corrupt.
 *
 * Deliberately a near-copy of cw-locations-editor.js rather than a shared
 * abstraction: two editors is not enough repetition to justify a framework, and
 * the field sets have nothing in common. If a third arrives, factor then.
 *
 * Unlock: the site-wide edit switch (admin Keys tab) or ?cwedit=1 / ?edit=1.
 * Auth is cw-admin-gate.js, so the owner is asked for the password at most once
 * per tab across all the on-site editors.
 *
 * Data is READ FROM THE PROXY when the panel opens, never embedded in the page:
 * visitors must not carry an editing payload, and re-reading on open means a
 * second tab's save cannot be silently clobbered by stale state.
 *
 * Class names avoid "-card"/"__card" and nothing that needs its own colour is a
 * <span>: cw-theme-base.css forces [class*="-card"] backgrounds and .cw-main
 * span colour with !important, and both have eaten UI in this theme before.
 *
 * Metafield shape, one object per testimonial:
 *   { "c": company, "p": person, "r": role, "q": quote, "u": url, "l": logo }
 */
(function () {
  if (!window.cwAdminGate) return;

  var params = new URLSearchParams(location.search);
  var wants = params.get('cwedit') === '1' || params.get('edit') === '1' ||
              location.hash.indexOf('cwedit') >= 0 ||
              window.cwAdminGate.isEditing();
  if (!wants) return;

  /* No section when the metafield is empty — the wall renders nothing at all.
     That is exactly when the owner most needs the editor, so fall back to a
     floating launcher instead of bailing out. */
  var section = document.getElementById('testimonials');

  var PROXY = 'https://cyclewash-admin-proxy.vvlars.workers.dev/rest/graphql.json';
  var SHOP_GID = 'gid://shopify/Shop/27217166471';
  var pw = null;
  var rows = [];

  function gql(query, variables) {
    return fetch(PROXY, {
      method: 'POST',
      headers: { 'content-type': 'application/json', 'X-CW-Admin-Pass': pw },
      body: JSON.stringify({ query: query, variables: variables || {} })
    }).then(function (r) {
      if (r.status === 401 || r.status === 403) throw new Error('Wrong admin password.');
      if (!r.ok) throw new Error('Proxy HTTP ' + r.status);
      return r.json();
    }).then(function (d) {
      if (d.errors && d.errors.length) throw new Error(d.errors[0].message);
      return d.data;
    });
  }

  function auth() {
    if (pw) return Promise.resolve(true);
    return window.cwAdminGate.getPass('Edit testimonials').then(function (v) {
      if (!v) return false;
      pw = v;
      return true;
    });
  }

  var css = document.createElement('style');
  css.textContent = [
    '.cwtme-open{display:inline-flex;align-items:center;gap:7px;margin:0 auto 26px;padding:8px 18px;border-radius:100px;cursor:pointer;font:600 13px Inter,sans-serif;background:rgba(255,195,0,.1);color:#FFC300;border:1px solid rgba(255,195,0,.5)}',
    '.cwtme-openwrap{display:flex;justify-content:center}',
    '.cwtme-modal{position:fixed;inset:0;z-index:100050;background:rgba(6,9,14,.9);display:none;flex-direction:column;padding:3vh 3vw;font:14px Inter,sans-serif}',
    '.cwtme-modal.open{display:flex}',
    '.cwtme-head{display:flex;gap:12px;align-items:center;margin-bottom:14px;color:#fff;font-weight:600;flex-wrap:wrap}',
    '.cwtme-head .cwtme-sp{margin-left:auto;display:flex;gap:8px}',
    '.cwtme-btn{font:600 13px Inter,sans-serif;border:0;border-radius:8px;padding:9px 16px;cursor:pointer}',
    '.cwtme-save{background:#FFC300;color:#14181f}.cwtme-save:disabled{opacity:.45;cursor:default}',
    '.cwtme-ghost{background:transparent;color:#c5ccd8;border:1px solid #26303f}',
    '.cwtme-add{background:#1E82C8;color:#fff}',
    '.cwtme-list{flex:1;overflow:auto;display:flex;flex-direction:column;gap:12px}',
    '.cwtme-row{background:#141b28;border:1px solid #26303f;border-radius:12px;padding:14px 16px;display:grid;gap:10px;grid-template-columns:repeat(auto-fit,minmax(180px,1fr))}',
    '.cwtme-f{display:flex;flex-direction:column;gap:4px}',
    '.cwtme-f.wide{grid-column:1/-1}',
    '.cwtme-f label{font:600 10.5px Inter,sans-serif;letter-spacing:.09em;text-transform:uppercase;color:#8b97a8}',
    '.cwtme-f input,.cwtme-f textarea{font:13px Inter,sans-serif;background:#0d1420;color:#f4f7fb;border:1px solid #26303f;border-radius:7px;padding:8px 10px;width:100%;box-sizing:border-box}',
    '.cwtme-f textarea{min-height:70px;resize:vertical}',
    '.cwtme-f input:focus,.cwtme-f textarea:focus{outline:0;border-color:#1E82C8}',
    '.cwtme-bad{border-color:#e5534b !important}',
    '.cwtme-tools{display:flex;gap:6px;align-items:flex-end;grid-column:1/-1;justify-content:flex-end}',
    '.cwtme-tools button{font:600 12px Inter,sans-serif;background:transparent;color:#9fb3c8;border:1px solid #26303f;border-radius:7px;padding:6px 11px;cursor:pointer}',
    '.cwtme-tools .cwtme-del{color:#ff6b81;border-color:rgba(255,107,129,.4)}',
    '.cwtme-msg{color:#9fb3c8;font-size:12.5px}',
    '.cwtme-msg.err{color:#ff6b81}.cwtme-msg.ok{color:#3fbf6f}'
  ].join('\n');
  document.head.appendChild(css);

  var modal = document.createElement('div');
  modal.className = 'cwtme-modal';
  modal.innerHTML =
    '<div class="cwtme-head"><b>Testimonials</b>' +
    '<div class="cwtme-msg" id="cwtme-msg">loading…</div>' +
    '<div class="cwtme-sp">' +
    '<button class="cwtme-btn cwtme-add" id="cwtme-add">+ Add testimonial</button>' +
    '<button class="cwtme-btn cwtme-save" id="cwtme-save">Save</button>' +
    '<button class="cwtme-btn cwtme-ghost" id="cwtme-close">Close</button>' +
    '</div></div><div class="cwtme-list" id="cwtme-list"></div>';
  document.body.appendChild(modal);

  var listEl = modal.querySelector('#cwtme-list');
  var msgEl = modal.querySelector('#cwtme-msg');

  function say(text, kind) {
    msgEl.textContent = text;
    msgEl.className = 'cwtme-msg' + (kind ? ' ' + kind : '');
  }

  function field(label, value, key, idx, wide, area) {
    var wrap = document.createElement('div');
    wrap.className = 'cwtme-f' + (wide ? ' wide' : '');
    var l = document.createElement('label');
    l.textContent = label;
    var input = document.createElement(area ? 'textarea' : 'input');
    input.value = value || '';
    input.addEventListener('input', function () {
      rows[idx][key] = input.value;
      input.classList.remove('cwtme-bad');
    });
    wrap.appendChild(l);
    wrap.appendChild(input);
    return wrap;
  }

  function render() {
    listEl.innerHTML = '';
    rows.forEach(function (row, i) {
      var el = document.createElement('div');
      el.className = 'cwtme-row';
      el.appendChild(field('Company', row.c, 'c', i));
      el.appendChild(field('Person', row.p, 'p', i));
      el.appendChild(field('Role', row.r, 'r', i));
      el.appendChild(field('Website URL', row.u, 'u', i));
      el.appendChild(field('Logo (asset filename or URL)', row.l, 'l', i, true));
      el.appendChild(field('Quote', row.q, 'q', i, true, true));

      var tools = document.createElement('div');
      tools.className = 'cwtme-tools';
      var up = document.createElement('button');
      up.textContent = '↑';
      up.disabled = i === 0;
      up.addEventListener('click', function () {
        var t = rows[i - 1]; rows[i - 1] = rows[i]; rows[i] = t; render();
      });
      var down = document.createElement('button');
      down.textContent = '↓';
      down.disabled = i === rows.length - 1;
      down.addEventListener('click', function () {
        var t = rows[i + 1]; rows[i + 1] = rows[i]; rows[i] = t; render();
      });
      var del = document.createElement('button');
      del.className = 'cwtme-del';
      del.textContent = 'Delete';
      del.addEventListener('click', function () {
        if (!confirm('Delete the testimonial from ' + (row.c || row.p || 'this entry') + '?')) return;
        rows.splice(i, 1); render();
      });
      tools.appendChild(up); tools.appendChild(down); tools.appendChild(del);
      el.appendChild(tools);
      listEl.appendChild(el);
    });
    say(rows.length + ' testimonial' + (rows.length === 1 ? '' : 's'));
  }

  function load() {
    say('loading…');
    return gql(
      'query { shop { metafield(namespace:"custom", key:"testimonials"){ value } } }'
    ).then(function (d) {
      var raw = d && d.shop && d.shop.metafield ? d.shop.metafield.value : '[]';
      var parsed;
      try { parsed = JSON.parse(raw || '[]'); } catch (e) { parsed = []; }
      rows = Array.isArray(parsed) ? parsed : [];
      render();
    });
  }

  function save() {
    /* A quote with no attribution is the one shape that reads as fake, so it is
       the only thing blocked outright. Everything else may legitimately be blank. */
    var bad = false;
    rows.forEach(function (r, i) {
      var hasWho = (r.c || '').trim() || (r.p || '').trim();
      if ((r.q || '').trim() && !hasWho) {
        bad = true;
        var inputs = listEl.children[i].querySelectorAll('input');
        if (inputs[0]) inputs[0].classList.add('cwtme-bad');
      }
    });
    if (bad) { say('A quote needs a company or a person.', 'err'); return; }

    var clean = rows.filter(function (r) {
      return (r.q || '').trim() || (r.c || '').trim() || (r.p || '').trim();
    }).map(function (r) {
      var o = {};
      ['c', 'p', 'r', 'q', 'u', 'l'].forEach(function (k) {
        var v = (r[k] || '').trim();
        if (v) o[k] = v;
      });
      return o;
    });

    say('saving…');
    gql(
      'mutation Set($m:[MetafieldsSetInput!]!){ metafieldsSet(metafields:$m){ userErrors{ message } } }',
      { m: [{ ownerId: SHOP_GID, namespace: 'custom', key: 'testimonials', type: 'json', value: JSON.stringify(clean) }] }
    ).then(function (d) {
      var errs = d.metafieldsSet && d.metafieldsSet.userErrors;
      if (errs && errs.length) throw new Error(errs[0].message);
      say('Saved. Reloading…', 'ok');
      setTimeout(function () { location.reload(); }, 700);
    }).catch(function (e) { say(e.message, 'err'); });
  }

  modal.querySelector('#cwtme-add').addEventListener('click', function () {
    rows.push({ c: '', p: '', r: '', q: '', u: '', l: '' });
    render();
    listEl.scrollTop = listEl.scrollHeight;
  });
  modal.querySelector('#cwtme-save').addEventListener('click', save);
  modal.querySelector('#cwtme-close').addEventListener('click', function () {
    modal.classList.remove('open');
  });

  var wrap = document.createElement('div');
  wrap.className = 'cwtme-openwrap';
  var open = document.createElement('button');
  open.className = 'cwtme-open';
  open.type = 'button';
  open.textContent = '✎ Edit testimonials';
  open.addEventListener('click', function () {
    auth().then(function (ok) {
      if (!ok) return;
      modal.classList.add('open');
      load().catch(function (e) { say(e.message, 'err'); });
    });
  });
  wrap.appendChild(open);

  if (section) {
    var container = section.querySelector('.cw-tw__inner') || section.firstElementChild || section;
    container.insertBefore(wrap, container.firstChild);
  } else {
    /* Empty wall: park the launcher bottom-left, clear of the WhatsApp and
       scroll-to-top buttons that already sit bottom-right. */
    wrap.style.cssText = 'position:fixed;left:18px;bottom:18px;z-index:100040';
    open.style.margin = '0';
    open.style.background = '#141b28';
    document.body.appendChild(wrap);
  }
})();
